import { userTypes, contractorLevelEnum } from './constants';

export const normalizePersonId = person => {
  if (person == null || person === '') return null;
  if (typeof person === 'object') {
    const id = person.id ?? person.userId;
    return id != null && id !== '' ? Number(id) : null;
  }
  const asNumber = Number(person);
  return Number.isFinite(asNumber) && asNumber > 0 ? asNumber : null;
};

export const canEdit = (creatorId, currentUserId) => {
  const creator = Number(creatorId);
  const user = Number(currentUserId);
  if (!creator || !user) return false;
  return creator === user;
};

export const isBasicContractorCompany = (companyType, companyLevel) =>
  companyType === userTypes.Contractor && companyLevel === contractorLevelEnum.BasicContractor;

export const isPsmAuditAdministrator = companyType => companyType === userTypes.SafetyCouncil;

export const canCreatePsmAudit = (userCompanyType, companyType, companyLevel) =>
  isPsmAuditAdministrator(userCompanyType) && !isBasicContractorCompany(companyType, companyLevel);

export const canViewPsmAuditDetails = companyType =>
  companyType === userTypes.SafetyCouncil || companyType === userTypes.Owner;

export const canEditPsmAsUser = (creatorId, currentUserId, companyType) =>
  isPsmAuditAdministrator(companyType) && canEdit(creatorId, currentUserId);
